module.exports = __webpack_public_path__ + "92367c34.png";


//////////////////
// WEBPACK FOOTER
// ./public/icons/Asset 3.3.png
// module id = 1313
// module chunks = 8